export const CONTEST_TYPES = {
  COOL: 1,
  BEAUTY: 2,
  CUTE: 3,
  SMART: 4,
  TOUGH: 5,
} as const;
